module.exports = __webpack_public_path__ + "static/img/kh-19.050b73e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-19.png
// module id = wWTs
// module chunks = 5